export const SET_CARI_FORM_PAGE_DATA = "SET_CARI_FORM_PAGE_DATA";

export const SET_ACTIVE_VERIFIED_LOGIN_USER_DATA = "export const SET_ACTIVE_VERIFIED_LOGIN_USER_DATA";

export const SET_ACTIVE_POSITION_DATA = "SET_ACTIVE_POSITION_DATA";

export const SET_ACTIVE_APPLICATION_DATA = "SET_ACTIVE_APPLICATION_DATA";

export const SET_CURRENT_USER_DATA = "SET_CURRENT_USER_DATA";

export const SET_URL_PARAM_DATA = "SET_URL_PARAM_DATA";

export const RESET_ALL_DATA = "RESET_ALL_DATA";

export const RESET_ACTIVE_POSITION_DATA = "RESET_ACTIVE_POSITION_DATA";

export const RESET_ACTIVE_APPLICATION_DATA = "RESET_ACTIVE_APPLICATION_DATA";

export const RESET_URL_PARAM_DATA = "RESET_URL_PARAM_DATA";

export const OPEN_CARI_MODAL = "OPEN_CARI_MODAL";

export const CLOSE_CARI_MODALS = "CLOSE_CARI_MODALS";